import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const UsingTabletIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g>
      <path
        d="M 215.820313 236.523438 C 230.598958 231.901042 324.869792 219.270833 329.752604 226.627604 C 334.960938 234.440104 321.028646 256.184896 317.643229 262.955729 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 200.455729 255.208333 C 193.033854 270.117188 138.411458 369.466146 141.015625 374.674479 C 184.635417 369.661458 267.838542 372.721354 277.473958 363.085938 C 283.203125 357.356771 284.440104 345.247396 288.997396 338.346354 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 264.257812 253.059896 C 263.802083 251.432292 265.364583 250.390625 265.885417 249.153646 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 83.723958 96.09375 C 118.294271 -5.859375 268.619792 41.536458 238.867188 147.330729 C 222.721354 204.752604 112.890625 231.705729 88.997396 140.494792 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 202.994792 130.143229 C 202.278646 124.674479 202.018229 121.354167 200.846354 116.471354 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 171.614583 131.119792 C 171.354167 126.5625 170.182292 123.177083 168.945312 118.75 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 305.533854 279.427083 C 299.283854 280.794271 293.489583 283.138021 288.476562 287.174479 C 243.489583 323.111979 311.588542 335.611979 332.486979 293.75 C 336.588542 285.611979 335.546875 276.627604 330.273438 270.117188 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 88.932292 248.307292 C 101.106771 196.875 177.018229 234.505208 167.057292 274.21875 C 161.197917 297.786458 139.908854 269.270833 136.783854 259.895833 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
      <path
        d="M 137.369792 268.945312 C 135.611979 293.033854 109.700521 282.356771 100.455729 269.466146 "
        transform="matrix(0.06,0,0,0.06,0,0)"
        fill="none"
        stroke="currentColor"
        strokeWidth={16}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={4}
        strokeOpacity={0.898039}
      />
    </g>
  </SvgIcon>
);

export default UsingTabletIcon;
